import "./RestoreOrderButton.less";
import { Button } from "antd";
import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import ShopDTO from "@/dto/shop/ShopDTO";
import OrderTab from "../../enum/OrderTab";
import { useOrderManagementStore } from "../../store/OrderManagementStore";
import { observer } from "mobx-react-lite";
import { useModalStore } from "@/hooks/Modal/hooks";
import RestoreOrdersModal from "../dialogs/RestoreOrdersDialog/RestoreOrdersModal";
import ConfirmRestoreModal from "../dialogs/RestoreOrdersDialog/ConfirmRestoreModal";
import MergeMergeableOrderModal from "../dialogs/MergeMergeableOrderDialog/MergeMergeableOrderModal";
import { AutoMergeMergerableOrderScene } from "@/services/api/order";

interface RestoreOrderButtonProps {
    getSelectedOrders(): OrderDTO[];

    shop: ShopDTO;
}

/**
 * 将『挂起订单』恢复到『待发货』按钮
 */
const RestoreOrderButton: React.FC<RestoreOrderButtonProps> = function (props) {
    const { shop, getSelectedOrders } = props;
    const modalStore = useModalStore();
    const orderManagementStore = useOrderManagementStore();

    return (
        <Button
            className="ec-restore-order-button mr3"
            type="primary"
            onClick={() => {
                const selectedOrders = getSelectedOrders();

                if (!selectedOrders) {
                    return;
                }

                modalStore.openModal(ConfirmRestoreModal, {
                    onRestore() {
                        modalStore.openModal(RestoreOrdersModal, {
                            orders: selectedOrders,
                            onSuccess() {
                                orderManagementStore.fetchOrders(shop.id, OrderTab.ON_HOLD);
                                orderManagementStore.getOrderListCount();
                            },
                        });
                    },
                    onRestoreMerge(autoMergeManualIndependentOrder) {
                        modalStore.openModal(RestoreOrdersModal, {
                            orders: selectedOrders,
                            async onSuccess() {
                                modalStore.openModal(MergeMergeableOrderModal, {
                                    orders: selectedOrders,
                                    autoMergeManualIndependentOrder,
                                    scene: AutoMergeMergerableOrderScene.RECOVER_HOLDING_ORDER,
                                    onDone() {
                                        orderManagementStore.fetchOrders(shop.id, OrderTab.ON_HOLD);
                                        orderManagementStore.getOrderListCount();
                                    },
                                });
                            },
                        });
                    },
                });
            }}
        >
            恢复到「待发货」中
        </Button>
    );
};

export default observer(RestoreOrderButton);
